<template>
  <div>
    <vs-card>
      <div class="vx-row mb-2">
        <!-- Codigo Mensagem -->
        <div class="vx-col sm:w-5/12 w-full">
          <vs-input
            class="w-full codigoMensagem"
            label="ID da Mensagem"
            name="codigoMensagem"
            size="default"
            v-model="form.codigoMensagem"
            v-validate="'required'"
            data-vv-as="'ID da Mensagem'"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'codigoMensagem',
              )
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'codigoMensagem',
              )
            "
            autocomplete="off"
            @keyup="removeEspaco($event)"
            :disabled="editMode"
          />
        </div>

        <!-- Assunto -->
        <div class="vx-col sm:w-5/12 w-full">
          <label for="Assunto">Assunto</label>
          <v-select
            :options="assuntos"
            name="Assunto"
            label="assunto"
            v-model="form.idMensageriaAssuntoMensagem"
            class="select-large w-full"
            :reduce="(item) => item.idMensageriaAssuntoMensagem"
            v-validate="'required'"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Assunto')
            "
            :class="
              utilsList.validateStateClass(
                this.veeFields,
                this.veeErrors,
                'Assunto',
              )
            "
          >
          </v-select>
        </div>

        <!-- Disparo da Mensagem -->
        <div class="vx-col sm:w-2/12 w-full flex items-center justify-center">
          <div class="flex items-center gap-3 mt-2 sm:mt-0 sm:flex-col">
            <label for="">Disparo da mensagem:</label>
            <vs-switch v-model="form.mensagemAtiva">
              <span slot="on">Ativo</span>
              <span slot="off">Inativo</span>
            </vs-switch>
          </div>
        </div>
      </div>
    </vs-card>

    <span class="mb-2 block">Canais</span>

    <!-- WhatsApp -->
    <vs-card>
      <!-- Canal Whatsapp -->
      <div class="vx-row" :class="{ 'mb-2': form.canalWhatsapp }">
        <div class="vx-col w-full">
          <vs-checkbox v-model="form.canalWhatsapp"
            >Enviar para Whatsapp</vs-checkbox
          >
        </div>
      </div>

      <!-- Template Whatsapp -->
      <div v-if="form.canalWhatsapp">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-textarea
              class="select-large w-full"
              label="Template WhatsApp"
              name="templateWhatsapp"
              ref="templateWhatsapp"
              v-model="form.templateWhatsapp"
              v-validate="'required'"
              data-vv-as="'Template Whatsapp'"
              :state="
                utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'templateWhatsapp',
                )
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'templateWhatsapp',
                )
              "
            />
          </div>
          <div class="vx-col w-full text-right">
            <a
              href="https://faq.whatsapp.com/539178204879377/?locale=pt_BR"
              target="_blank"
              >Como formatar suas mensagens</a
            >
          </div>
        </div>
        <!-- Botões com as Variaveis para o WhatsApp-->
        <div class="vx-row flex-col" v-if="availableVariables !== null">
          <div class="vx-col mb-2">
            <span>Variáveis Disponíveis</span>
          </div>
          <div class="vx-col mb-2">
            <vs-button
              v-for="(variavel, index) in availableVariables"
              :key="index"
              color="primary"
              type="filled"
              class="mr-3 mb-3"
              @click="useVariavel('Whatsapp', variavel)"
              >{{ variavel.nome }}</vs-button
            >
          </div>
        </div>
      </div>
    </vs-card>

    <!-- Email -->
    <vs-card>
      <!-- Canal Email -->
      <div class="vx-row" :class="{ 'mb-2': form.canalEmail }">
        <div class="vx-col w-full">
          <vs-checkbox v-model="form.canalEmail">Enviar para Email</vs-checkbox>
        </div>
      </div>

      <!-- Template Assunto Email -->
      <div v-if="form.canalEmail">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="w-full inputBorder mb-2"
              label="Assunto Email"
              name="assuntoEmail"
              ref="assuntoEmail"
              v-model="form.assuntoEmail"
              v-validate="'required'"
              data-vv-as="assuntoEmail"
              :state="
                utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'assuntoEmail',
                )
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'assuntoEmail',
                )
              "
            />

            <vs-textarea
              class="select-large w-full"
              label="Template Email"
              name="templateEmail"
              ref="templateEmail"
              v-model="form.templateEmail"
              v-validate="'required'"
              data-vv-as="templateEmail"
              :state="
                utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'templateEmail',
                )
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'templateEmail',
                )
              "
            />
          </div>
          <div class="vx-col w-full text-right">
            <a
              href="https://developer.mozilla.org/pt-BR/docs/Web/HTML"
              target="_blank"
              >Trate o campo acima como uma folha de HTML</a
            >
          </div>
        </div>
        <!-- Botões com as Variaveis para o Email-->
        <div class="vx-row flex-col" v-if="availableVariables !== null">
          <div class="vx-col mb-2">
            <span>Variáveis Disponíveis</span>
          </div>
          <div class="vx-col mb-2">
            <vs-button
              v-for="(variavel, index) in availableVariables"
              :key="index"
              color="primary"
              type="filled"
              class="mr-3 mb-3"
              @click="useVariavel('Email', variavel)"
              >{{ variavel.nome }}</vs-button
            >
          </div>
        </div>
      </div>
    </vs-card>

    <!-- SMS -->
    <vs-card>
      <!-- Canal SMS -->
      <div class="vx-row" :class="{ 'mb-2': form.canalSms }">
        <div class="vx-col w-full">
          <vs-checkbox v-model="form.canalSms">Enviar para SMS</vs-checkbox>
        </div>
      </div>
      <!-- Template SMS -->
      <div v-if="form.canalSms">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-textarea
              maxLength="160"
              class="select-large w-full"
              label="Template SMS"
              name="templateSms"
              ref="templateSms"
              v-model="form.templateSms"
              v-validate="'required'"
              data-vv-as="'Template SMS'"
              :state="
                utilsList.validateState(
                  this.veeFields,
                  this.veeErrors,
                  'templateSms',
                )
              "
              :class="
                utilsList.validateStateClass(
                  this.veeFields,
                  this.veeErrors,
                  'templateSms',
                )
              "
            />
          </div>
          <div class="vx-col w-full flex justify-between">
            <a
              >Quantidade de caracteres:
              {{ form.templateSms ? form.templateSms.length : 0 }}</a
            >
            <a class="cursor-pointer" @click="openModalCaracteresSms = true"
              >Saiba mais sobre os limites de caracteres</a
            >
          </div>
        </div>
        <!-- Botões com as Variaveis para o SMS-->
        <div class="vx-row flex-col" v-if="availableVariables !== null">
          <div class="vx-col mb-2">
            <span>Variáveis Disponíveis</span>
          </div>
          <div class="vx-col mb-2">
            <vs-button
              v-for="(variavel, index) in availableVariables"
              :key="index"
              color="primary"
              type="filled"
              class="mr-3 mb-3"
              @click="useVariavel('Sms', variavel)"
              >{{ variavel.nome }}</vs-button
            >
          </div>
        </div>
      </div>
    </vs-card>

    <!-- Registros de históricos de envios -->
    <span class="mb-2 block">Registros de histórico como:</span>
    <vs-card>
      <div class="vx-row my-2">
        <div class="vx-col">
          <vs-checkbox v-model="form.logBoleto">Boleto</vs-checkbox>
        </div>
      </div>
    </vs-card>

    <!-- Mensagem de Validação -->
    <vs-card v-if="$validator.errors.all().length > 0">
      <vs-alert
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
    </vs-card>

    <!-- Botão de Salvar -->
    <div class="vx-row mt-3">
      <div class="vx-col w-full text-right">
        <BotaoSubmit
          v-if="$can('Escrita', 'Associados')"
          variant="success"
          :edit="true"
          :aguarde="processingSave"
          @submit="onSubmit()"
        ></BotaoSubmit>
      </div>
    </div>

    <!-- PopUp sobre informações de caracteres para SMS -->
    <vs-popup
      :title="'Limite de caracteres para SMS'"
      :active.sync="openModalCaracteresSms"
      @close="openModalCaracteresSms = false"
      ><div>
        <p class="m-2">
          <b>160</b> para SMS usando somente caracteres normais: letras sem
          acentos, números, :, !, ? por exemplo.
        </p>
        <p class="m-2">
          <b>140</b> para SMS usando caracteres com símbolos especiais: ], [, },
          {, |, € por exemplo.
        </p>
        <p class="m-2">
          <b>70</b> para SMS usando caracteres com acentos ou emojis: à, ú, ê,
          😉️ por exemplo.
        </p>
      </div>
      <div>
        <p class="m-2">
          <b>ATENÇÃO!</b> Cuidado com o uso das variáveis, pois como o tamanho
          delas não é definido, elas podem quebrar o seu limite de caracteres.
        </p>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// Component
import BotaoSubmit from './../../../../components/BotaoSubmit';
import vSelect from 'vue-select';

// Util
import notify from './../../../../utils/notify';
import utilsList from './../../../../utils/list';

import {
  clearTemplate,
  getAssuntos,
  getAvailableVariables,
  getMensagem,
  postMensagem,
  putMensagem,
} from './utils/mensageria-form.js';

export default {
  data() {
    return {
      processingSave: false,
      processingLoad: true,
      availableVariables: null,
      editMode: false,
      form: {
        idMensageriaMensagem: null,
        codigoMensagem: null,
        idMensageriaAssuntoMensagem: null,
        canalWhatsapp: true,
        templateWhatsapp: null,
        canalSms: false,
        templateSms: null,
        canalEmail: false,
        templateEmail: null,
        assuntoEmail: null,
        mensagemAtiva: false,
        logBoleto: false,
      },
      assuntos: [],
      mensagem: null,
      utilsList,
      openModalCaracteresSms: false,
    };
  },
  watch: {
    'form.idMensageriaAssuntoMensagem': function (newValue) {
      if (!this.processingLoad) {
        clearTemplate(this.form);
        this.setAvailableVariables(newValue);
      }
    },
    'form.canalWhatsapp': function () {
      if (!this.processingLoad) {
        clearTemplate(this.form, 'Whatsapp');
      }
    },
    'form.canalSms': function () {
      if (!this.processingLoad) {
        clearTemplate(this.form, 'Sms');
      }
    },
    'form.canalEmail': function () {
      if (!this.processingLoad) {
        clearTemplate(this.form, 'Email');
      }
    },
  },
  methods: {
    useVariavel(campo, itemVariavel) {
      const nameProp = `template${campo}`;
      const textarea = this.$refs[nameProp].$el.querySelector('textarea');
      const posicaoInsercao = textarea.selectionStart;

      const textoAntes = this.form[nameProp].substring(0, posicaoInsercao);
      const textoDepois = this.form[nameProp].substring(posicaoInsercao);
      const variavelInserida = ` ${itemVariavel.variavel} `;

      this.form[nameProp] = `${textoAntes}${variavelInserida}${textoDepois}`;
      this.$nextTick(() => {
        const novaPosicao = posicaoInsercao + variavelInserida.length;
        textarea.setSelectionRange(novaPosicao, novaPosicao);
        textarea.focus();
      });
    },
    async getData() {
      this.$vs.loading();

      const { idMensagem } = this.$route.params;
      const arrayPromise = [];
      const assunto = getAssuntos();

      arrayPromise.push(assunto);

      if (idMensagem) {
        const mensagem = getMensagem(idMensagem);
        arrayPromise.push(mensagem);
        this.editMode = true;
      }

      try {
        const [assuntos, mensagem] = await Promise.all(arrayPromise);

        this.assuntos = assuntos ? assuntos : null;

        if (mensagem) {
          this.form = mensagem;
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();

        // POG
        setTimeout(() => {
          this.setAvailableVariables(this.form.idMensageriaAssuntoMensagem);
          this.processingLoad = false;
        }, 500);
      }
    },
    async onSubmit() {
      try {
        const { idMensagem } = this.$route.params;
        const validateForm = await this.validateForm();

        if (!validateForm) {
          return;
        }

        this.$vs.loading();

        !idMensagem
          ? await postMensagem(this.form)
          : await putMensagem(idMensagem, this.form);

        notify.notifySuccess(
          this.$vs,
          !idMensagem
            ? 'Mensagem criado com sucesso!'
            : 'Mensagem atualizada com sucesso!',
        );

        this.$router.replace('/mensageria');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async validateForm() {
      if (this.form.codigoMensagem) {
        this.form.codigoMensagem = this.form.codigoMensagem.toUpperCase();
      }
      return await this.$validator.validateAll();
    },
    setAvailableVariables(idMensageriaAssuntoMensagem) {
      this.availableVariables = getAvailableVariables(
        this.assuntos,
        idMensageriaAssuntoMensagem,
      );
    },
    removeEspaco(event) {
      const input = event.target;
      input.value = input.value.replace(new RegExp(' ', 'g'), '-');
    },
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
  height: 38px;
}

.vs-textarea-primary.has-error {
  border: 1px solid rgba(var(--vs-danger), 1) !important;
}

.codigoMensagem {
  input {
    text-transform: uppercase;
  }
}

.inputBorder {
  div {
    input {
      border: 1px solid rgba(0, 0, 0, 0.08) !important;
    }
  }
}

[name='codigoMensagem']:disabled {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
